import consultRequestCreator from '../../consultRequestCreator';
import urlConstants from '../../../constants/urlConstants';

export const fetchOnlineDoctors = function (params) {
  return consultRequestCreator
    .get(urlConstants.GET_PAID_DOCTORS, { params })
    .then(response => response.data);
};
